<div class="flex box-border-active pb-4">
    <div class="col-span-1">
        <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">{{currentApplicationStep}}/{{totalApplicationSteps}}</h2>
    </div>
    <div class="col-span-9">
        <h2 class="text-lg font-bold my-6">Upload Documents</h2>
        <div *ngIf="!verifastEnabled">
            <p *ngIf="AddAdditionalApplicantKey == null">Please provide most recent proof of income, bank statements,
                and government issued identification.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName == null">Please provide most
                recent proof of income, bank statements, and government issued identification for the additional
                applicant.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName != null">Please provide most
                recent proof of income, bank statements, and government issued identification for
                {{AddAdditionalApplicantName}}.</p>
        </div>
        <div *ngIf="verifastEnabled">
            <p>Option to provide additional documentation of income that would not already be reflected
               in your bank statements or pay stubs. Examples include offer letters or future employment contracts.</p>
        </div>
        <div>
            <p class="text-sm font-bold">*CA residents may also use this section  to upload proof of housing vouchers.</p>
        </div>
        <div *ngIf="errorMessage!=null" class="alert alert-danger">
            {{ errorMessage }}
        </div>
    </div>
</div>

<div class="px-8">
    <form #docForm="ngForm">
        <table class="doc-table">
            <thead>
                <th class="w-3/12 px-4 py-2 text-sm">Name</th>
                <th class="w-4/12 px-4 py-2 text-sm">Date Created</th>
                <th class="w-4/12 px-4 py-2 text-sm">Document Type</th>
                <th class="w-1/12 px-4 py-2 text-sm"> </th>
            </thead>
            <tr *ngFor="let doc of documents; let i = index; first as isFirst">
                <td class="text-sm text-center">{{doc.Name}}</td>
                <td class="text-sm text-center">{{doc.DateUploaded | date:'medium'}}
                  <span *ngIf="doc.Category == 'POI' && isDocumentOutdated(doc.DateUploaded)" style="color: #FF3C00;">(Outdated)</span>
                </td>
                <mat-select class="text-sm text-center" name="Category[{{i}}]" id="Category[{{i}}]"
                    (selectionChange)="onDocChange(doc)" required [(ngModel)]="doc.Category">
                    <mat-option *ngFor="let documentType of documentTypes" [value]="documentType.value"
                    [ngStyle]="{ display : (documentType.value === 'DL' || documentType.value === 'OtherID') && verifastEnabled  ? 'none' : 'block' }">
                        {{documentType.label}}
                    </mat-option>
                </mat-select>
                <td class="text-center"><button type="button" class="text-red-700 font-bold" (click)="onDocDelete(doc)">X</button></td>
            </tr>
        </table>
        <div *ngIf="isUploading" class="flex justify-center"><mat-progress-spinner
            mode="indeterminate"></mat-progress-spinner>
            Up-Loading Data....
        </div>
        <div  *ngIf="!isUploading" class="flex flex-col sm:justify-between sm:flex-row">
            <div class="mt-8">
                <label class="mat-input-button">
                    <span>UPLOAD DOCUMENT</span>
                    <input type="file" class="hidden" (change)="uploadFiles($event)">
                </label>
            </div>
        </div>
        <div  *ngIf="!isUploading" class="text-right mt-8">
            <button mat-flat-button color="primary" class="h-10 px-6 my-2" (click)="cancelEdit()"
                *ngIf="AddAdditionalApplicantKey != null">CANCEL EDIT</button>
            <button mat-flat-button color="primary" class="h-10 px-6 my-2 ml-2"
                (click)="onContinueClick()" [disabled]="disableSubmitBtn">CONTINUE</button>
        </div>
    </form>
</div>
